import { useContext } from 'react';

import HeaderContext from '../_context';

const useHeader = () => {
  const context = useContext(HeaderContext);

  return {
    ...context,
  };
};

export default useHeader;
